import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import Avatar from "../../../../../components/Avatar";
import { createAvatarName, hasImage } from "../../../../../utils";
import { useBoardUsers } from "../../../../../reactQuery/users";
import { updateBoard } from "../../../../../services/apiBoards";
import { isAdmin } from "../../../../../utils/constants";
import { useResponsive } from "../../../../../hooks/useResponsive";
import useToastPromise from "../../../../../hooks/useToast";
import CustomMenu from "../../../../../components/Menu";
import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";
import { getResponseData } from "../../../../../reactQuery/response";

function AssignBoardOwner({ board }) {
  const { id } = useBoardIdByKey();
  const queryClient = useQueryClient();
  const [anchorEl, setAnchorEl] = useState(null);
  const [users, setUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const open = Boolean(anchorEl);
  const isMobile = useResponsive("down", "md");
  const { showToastPromise } = useToastPromise();

  const { isLoading, data } = useBoardUsers(id);

  useEffect(() => {
    const sortedUsers = getResponseData(data, []).length
      ? getResponseData(data, []).sort(function (a, b) {
          return a.username.localeCompare(b.username);
        })
      : [];

    const updatedUsers = sortedUsers?.reduce((acc, user) => {
      if (user.user_id == board?.owner_user_id) {
        acc.unshift(user);
      } else {
        acc.push(user);
      }
      return acc;
    }, []);

    const activeUsers = updatedUsers?.filter((user) => user?.active) || [];
    setUsers(activeUsers);
  }, [board, data, id, isLoading]);

  const handleClick = (event) => {
    if (board?.is_owner || isAdmin())
      setAnchorEl(event.currentTarget);
  };
  const handleClose = (action) => {
    setAnchorEl(null);
  };

  const { mutate: assignBoardMutate } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(updateBoard, data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: [`boards`],
      });
      queryClient.invalidateQueries({
        queryKey: [`boardName`, id],
      });
      setLoading(false);
      setOpenDialog(false);
    },
    onError: (error) => {
      console.error("Error assig board", error);
      setLoading(false);
      setOpenDialog(false);
    },
  });

  const callback = () => {
    setLoading(true);
    assignBoardMutate({
      board_id: id,
      data: { owner_user_id: userId.user_id },
    });
  };

  const assignUser = (id) => {
    setOpenDialog(true);
    setUserId(id);
  };

  return (
    <>
      {openDialog && (
        <FormDialog
          open={openDialog}
          handleClose={() => setOpenDialog(false)}
          handleSubmit={callback}
          loading={loading}
          buttonTxt={"Assign"}
          title={"Confirmation: Assign Board Owner"}
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure to assign {userId.username} as Board Owner?
          </Typography>
        </FormDialog>
      )}
      <div
        onClick={handleClick}
        className={
          board?.is_owner || isAdmin()
            ? "board-owner-avtar-click"
            : ""
        }>
        <Avatar
          key={`user-avtar-${board?.owner_user_id}`}
          username={board?.board_owner_username}
          user_image={board?.board_owner_image}
          title={board?.board_owner_username}
          className={isMobile ? "mobile_avatar" : "header-avatar user-avatar"}
          isAdmin={board?.is_owner}
          // sx={{ width: isMobile ? "14px" : "" }}
          style={
            !hasImage(board?.board_owner_image) && {
              bgcolor: board?.board_owner_profile_color?.background,
              color: board?.board_owner_profile_color?.text,
            }
          }>
          {createAvatarName(board?.board_owner_username || "")}
        </Avatar>
      </div>
      <CustomMenu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        className="assign-board-owner-list assihn-board-owner"
        transformOrigin={{ horizontal: "left", vertical: "top" }}
       anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
       >
        {users.map((el) => {
          return (
            <CustomMenuItem
              key={`user-avtar-dropdown-admin-assign-${el.user_id}`}
              onClick={() => assignUser(el)}
              className={
                board?.owner_user_id == el.user_id
                  ? "active-assign"
                  : ""
              }>
              <Avatar
                key={`user-avtar-${el.user_id}`}
                username={el.username}
                user_image={el.user_image}
                title={el.username}
                className="user-avtar-dropdown user-avatar mr-8"
                style={
                  !hasImage(el.user_image) && {
                    bgcolor: el?.profile_color?.background,
                    color: el?.profile_color?.text,
                  }
                }>
                {createAvatarName(el.username)}
              </Avatar>

              {el.username}
            </CustomMenuItem>
          );
        })}
      </CustomMenu>
    </>
  );
}

export default AssignBoardOwner;
